<template>
  <div
    class="rte-content rte"
    v-html="formattedContent"
  />
</template>

<script>

/**
 * Vue: RTE content (rte-content)
 * -----------------------------------------------------------------------------
 * Component to standardise output of Shopify RTE content.
 *
 * @param {String} content - RTE content.
 * @param {Number} [imageWidth] - RTE content image width.
 *
 */
export default {
  name: 'RteContent',

  props: {
    content: {
      type: String,
      default: '',
      required: true,
    },
    imageWidth: {
      type: Number,
      default: 920,
    },
  },

  computed: {

    /**
     * Format content with standard classes and update image size.
     * @returns {String}
     */
    formattedContent() {
      if (!this.content) {
        return ''
      }

      return this.$localizeRichtext(
        this.content
          .replace(/(?:480x480|600x600|1024x1024|2048x2048)/g, `${this.imageWidth}x`)
          .replaceAll('<p><img', '<img')
          .replaceAll('alt></p>', 'alt>')
          .replaceAll('"></p>', '">')
          .replaceAll('<p', '<p class="text-body-2xs-regular"')
          .replaceAll('<li', '<li class="text-body-2xs-regular"')
          .replaceAll('<strong', '<strong class="text-heading-s text-heading-m-desktop"')
          .replaceAll('<h2', '<h2 class="text-heading-4xl"')
          .replaceAll('<h3', '<h3 class="text-heading-3xl"')
          .replaceAll('<h4', '<h4 class="text-heading-2xl"')
          .replaceAll('<h5', '<h5 class="text-heading-xl"')
          .replaceAll('<h6', '<h6 class="text-heading-l"')
          .replaceAll('<th', '<th class="text-body-s-regular"')
          .replaceAll('<td', '<td class="text-body-s-regular"'),
      )
    },
  },
}
</script>
